import type { ShipDef } from '../../sim/defs';
import { Stat } from '../../sim/stats';

/** V03 — LANCE. « Coque fragile, cadence élevée » (nœud `vaisseau-lance`,
 *  1 400 crédits, ouvert par le jalon « monde 2 franchi »).
 *
 *  ── Pourquoi ce fichier existe ────────────────────────────────────────────
 *  Le nœud était vendu 1 400 crédits et n'ouvrait rien : son `grants: 'lance'`
 *  ne désignait aucune coque. C'était le dernier des quinze nœuds fantômes de
 *  l'arbre, et le seul que l'audit avait laissé passer — parce que « lance »
 *  ressemble à `lance-perforante`, l'arme secondaire offerte d'office, et que
 *  la vérification s'était arrêtée à la ressemblance.
 *
 *  ── L'échange ────────────────────────────────────────────────────────────
 *  Une vie de moins contre un quart de cadence en plus. C'est le marché le plus
 *  franc des trois coques, et le seul qui déplace vraiment le curseur du RISQUE
 *  plutôt que celui du confort : l'AEGIS achète de la marge, le FANAL échange
 *  une ressource contre une autre, le LANCE parie.
 *
 *  Deux vies au lieu de trois, ce n'est pas −33 % de survie : c'est la
 *  disparition de la seconde erreur. Un joueur qui meurt une fois par monde
 *  finit la campagne avec le VULCAN et pas avec celui-ci. C'est cher, et c'est
 *  voulu — sans cela, +25 % de cadence serait un bonus déguisé en choix.
 *
 *  ── Ce que le nœud promettait en trop ─────────────────────────────────────
 *  ⚠️ Son texte annonçait aussi une « hitbox réduite ». Cette promesse a été
 *  RETIRÉE du nœud plutôt qu'implémentée, et il faut dire pourquoi : le rayon
 *  de la hitbox est une constante de `FEEL`, pas une statistique, et le point
 *  blanc de neuf unités toujours affiché est le contrat central du jeu — c'est
 *  lui qui rend un rideau franchissable plutôt qu'arbitraire.
 *
 *  Le rendre variable demanderait de le faire varier aussi À L'ÉCRAN, faute de
 *  quoi le joueur verrait un point et en toucherait un autre. Ce n'est pas une
 *  ligne de code, c'est une entaille dans la seule règle de lisibilité que le
 *  jeu ne négocie jamais. Mieux valait corriger le texte que le contrat.
 *
 *  ── Tout-multiplicatif ────────────────────────────────────────────────────
 *  Comme les deux autres coques : `computeStats` applique tous les additifs
 *  avant tous les multiplicatifs, donc le rapport au VULCAN survit aux cartes
 *  ramassées ensuite. Un `−1` additif sur les vies serait annulé par la
 *  première carte de la branche PV.
 */
const lance: ShipDef = {
  id: 'lance',
  name: 'LANCE',
  text: 'Une vie de moins, un quart de cadence en plus.',
  // Aucune promesse hors statistiques : le LANCE ne joue que sur le couple
  // vies/cadence, et c'est ce qui le rend lisible face aux deux autres coques,
  // dont les contreparties vivent en dehors de `StatBlock`.
  secondaryCooldownMul: 1,
  grazeBombCharge: 0,
  modifiers: [
    // 3 vies × 0,667 = 2,001 → `armPlayer` plancher à l'entier inférieur, soit 2.
    { stat: Stat.MaxLives, op: 'mul', value: -1 / 3 },
    { stat: Stat.FireRate, op: 'mul', value: 0.25 },
  ],
};

export default lance;
